import { useQuery } from "@apollo/client";
import { endOfDay, startOfDay } from "date-fns";

import { gql } from "~/__generated__";
import { parseDateToString } from "~/modules/app/util/dateHelpers";

export const FIELDWORKER_GET_CALENDAR_DAYS_EVENTS = gql(`
    query FieldworkerGetCalendarDaysEvents($userId: ID!, $startAt: DateTimeISO!, $endAt: DateTimeISO!) {
        fieldworkerGetCalendarDaysEvents(userId: $userId, startAt: $startAt, endAt: $endAt) {
            date
            availabilities {
                id
                name
                status
            }
        }
    }
`);

export default function useFieldworkerGetCalendarDaysEvents(userId: string, startAt: Date, endAt: Date) {
    const { data, loading, error } = useQuery(FIELDWORKER_GET_CALENDAR_DAYS_EVENTS, {
        variables: {
            userId,
            startAt: parseDateToString(startOfDay(startAt), "date"),
            endAt: parseDateToString(endOfDay(endAt), "date"),
        },
        fetchPolicy: "no-cache",
    });

    return {
        loading,
        error,
        data: data?.fieldworkerGetCalendarDaysEvents,
    };
}
